import React from "react";

import AdaptiveImage from "@/components/AdaptiveImage";
import AnimateLines from "@/components/AnimateLine";
import ImageItem from "@/components/ImageItem";

import { AnimateProps } from "../../../types";
import { getDiffTime } from "@/utils";

import "./index.css";

const Part1: React.FC<AnimateProps> = (props) => {
  const { data } = props;
  const address = data.user.address;

  const str =
    address.substring(0, 4) + "..." + address.substring(address.length - 4);
  const name = data.user.twitter_name || data.user.ens || str;

  return (
    <div className="part_contain part_contain_1">
      <div style={{ flex: 1, width: "100%" }} />
      <div className="part_content">
        <AnimateLines animateType={props.type}>
          <span className="text_title">Dear</span>
          <div className="row_center mb_16">
            <ImageItem is_whale={data.user.is_whale} type='avatar' url={data.user.avatar || ''} />
            <p className="text_remind">{name}</p>
          </div>
          {data.first_follow_timestamp ? (
            <>
              <p className={"text_content"}>In 2022, NFTTrack has been</p>
              <p>
                <span className={"text_content"}>with you for</span>&ensp;
                <span className="text_num">
                  {getDiffTime(data.first_follow_timestamp)}
                </span>&ensp;
                <span className={"text_content"}>since</span>
              </p>
              <p className={"text_content"}>you first followed addresses.</p>
            </>
          ) : (
            <>
              <p className={"text_content"}>Happy to see you at the end</p>
              <p className={"text_content"}> of 2022!</p>
            </>
          )}
        </AnimateLines>
      </div>
      <div style={{ flex: 1, width: "100%" }} />
      <AnimateLines animateType={props.type} animateName="animate__fadeIn">
        <div className="ml_auto">
          <AdaptiveImage name="Frame101022" />
        </div>
      </AnimateLines>
      <div style={{ flex: 2, width: "100%" }} />
    </div>
  );
};

export default Part1;
